var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.loading)?_c('div',{staticClass:"vuetify-content-dialog grow"},[_c('v-progress-circular',_vm._b({},'v-progress-circular',_vm.loadingVOptions,false)),(_vm.label)?_c('h6',{staticClass:"text-subtitle-1 mt-4"},[_vm._v(_vm._s(_vm.label))]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }